//unholy imports - setup stuff
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import type  { User } from "firebase/auth";
import { auth } from "./assets/Logic/firebase";
//components below
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
//website pages below
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import GamesPage from "./pages/GamesPage";
import ProfilePage from "./pages/ProfilePage";
import AboutPage from "./pages/AboutPage";
//games below
import Wordle from "./games/Wordle/Wordle";
import Hangman from "./games/Hangman/Hangman";
import Sudoku from "./games/Sudoku";
import TicTacToe from "./games/TicTacToe";


export default function App() {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, setUser);
    return unsub;
  }, []);
// routes for files
  return (
    <div className="app">
      <Navbar user={user} />
      <main>
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/games/wordle" element={<Wordle />} />
          <Route path="/games/hangman" element={<Hangman />} />
          <Route path="/games/sudoku" element={<Sudoku />} />
          <Route path="/games/tictactoe" element={<TicTacToe />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<div style={{ padding: "4rem", textAlign: "center" }}>404</div>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}